import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserFollowedPath } = getCRUDHooks({
  entityName: 'followedPath',
  get: ({ userId }: { userId: number }) =>
    clientApi.getOCClient().helpers.learningActivity.followedPath.get(userId),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserFollowedPath,
};
